import {NavLink} from "react-router-dom";

export default function SectionWhatWeDo1({_data}) {
  return (
    <div className="section-full p-t120 p-b90 site-bg-gray tw-what-wedo-area" id='about-us'>

      <div className="container">

        {/*<div className="flex justify-center">
          <div
            className="bg-teal-100 flex justify-center border-t-4 border-teal-500
             w-100
             rounded-[10px] text-teal-900 px-4 py-3 shadow-md mb-5 -mt-[20px]"
            role="alert">
            <div className="flex items-center">
              <div className="">
                <svg className="fill-current h-[20px] w-[20px] text-teal-500 mr-4"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                    d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
                </svg>
              </div>
              <div>
                Diákoknak 2025 szeptember 30-ig <b>- 15%</b> kedvezmény a költözésre!
              </div>
            </div>
          </div>
        </div>*/}

        {/* <!-- TITLE START--> */}
        <div className="section-head center wt-small-separator-outer">
          <div className="wt-small-separator site-text-primary">
            <div>{_data.title}</div>
          </div>
          <h2 className="wt-title">{_data.subtitle}</h2>
          <p className="section-head-text" dangerouslySetInnerHTML={{__html: _data.description}}></p>
        </div>
        {/* <!-- TITLE END--> */}

        <div className="tw-what-wedo-section">

          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-12 flex items-center">
              <div className="tw-what-wedo-media">
                <img src={_data.image} alt="#"/>
              </div>
            </div>

            <div className="col-xl-7 col-lg-7 col-md-12">
              <div className="tw-service-icon-box-wrap">
                {
                  _data.works.map((_object, index) => (
                    <div key={index} className="service-icon-box-two">

                      <div className="service-icon-box-two-media">
                        <img src={_object.icon} alt="#"/>
                      </div>

                      <div className="service-icon-box-title">
                        <h3 className="wt-title">
                          <a>
                                                      <span
                                                        className="site-text-primary">{_object.serial}</span>{_object.title}
                          </a>
                        </h3>
                        <p>{_object.description}</p>
                      </div>

                    </div>
                  ))
                }
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  )
}